var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize:debounce.100",value:(_vm.onResize),expression:"onResize",arg:"debounce",modifiers:{"100":true}}],attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }